import { Controller } from "@hotwired/stimulus"

/**
 * Search content
 * 
 * Add search target to the input field
 * Add element to the searchable containers
 * Add [data-searchable] to the searchable elements 
 */
export default class extends Controller {
    static targets = [ 'search', 'element' ];

    connect() {
        this.debounceTimer;

        this.searchTarget.addEventListener('keyup', (evt) => {
            this.debounce(400, evt);
        })
    }

    // Search through 'elementTargets' for [data-searchable] and search on the content of these elements
    search(str) {

        var searchStr = str.toLowerCase();
    
        // Check if search is empty
        if(searchStr === '') {
        
            this.elementTargets.forEach((element) => {
                if(element.classList.contains('hidden')) {
                    element.classList.remove('hidden');
                }
            });
        }
    
        // Check all blocks
        this.elementTargets.forEach((block) => {
    
            var cells = block.querySelectorAll('[data-searchable="1"]');
        
            if (cells.length === 0) {
                return;
            }
        
            var found = false;
        
            cells.forEach((cell) => {
                if(cell.textContent.toLowerCase().indexOf(searchStr) !== -1) {
                found = 1;
                return;
                }
            });
        
            if(found) {
                block.classList.remove('hidden');
            } else {
                block.classList.add('hidden');
            }
    
        });
    }

    // Add delay to searching after keyup
    debounce(time, evt) {
        window.clearTimeout(this.debounceTimer);
        
        this.debounceTimer = window.setTimeout(() => {
            this.search(evt.target.value);
        }, time)
    };

    
}